import * as React from 'react';
import { useState, useRef } from 'react';
import '../cadetes/cosa.css';
import axios from 'axios';
import csvToJson from 'csvtojson';
import { Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';

function CargaMasiva(props) {
  const [cargando, setCargando] = useState(false);
  const fileInputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const camposObligatorios = ['dniCertificado', 'apellidoNombre', 'calidadDe', 'grado'];

  const headers = [
    { label: "dniCertificado", key: "dniCertificado" },
    { label: "apellidoNombre", key: "apellidoNombre" },
    { label: "calidadDe", key: "calidadDe" },
    { label: "grado", key: "grado" }
  ];

  const tieneTodosLosCampos = (listado, campos) =>
    listado.every(item =>
      campos.every(field => item.hasOwnProperty(field)) &&
      Object.keys(item).length === campos.length
    );

  const comparaExistenciasPorDNI = (nuevoListado, existentes) => {
    const existentesSet = new Set(existentes.map(item => item.dniCertificado));
    return {
      repetidos: nuevoListado.filter(item => existentesSet.has(item.dniCertificado)),
      paraAgregar: nuevoListado.filter(item => !existentesSet.has(item.dniCertificado)),
    };
  };

  /* =========================
     LECTURA DE ARCHIVOS
  ========================= */

  const manejarCSV = (file) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => {
      const contenido = reader.result;
      const separador = contenido.includes(";") ? ";" : ",";
      csvToJson({ checkType: true, delimiter: separador })
        .fromString(contenido)
        .then(jsonData => subirArchivo(jsonData));
    };
    reader.onerror = () => {
      Swal.fire("Error", "No se pudo leer el archivo CSV.", "error");
    };
  };

  const manejarExcel = (file) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      subirArchivo(jsonData);
    };
    reader.onerror = () => {
      Swal.fire("Error", "No se pudo leer el archivo Excel.", "error");
    };
  };

  const manejarArchivo = (file) => {
    const extension = file.name.split('.').pop().toLowerCase();

    if (extension === 'csv') {
      manejarCSV(file);
    } else if (extension === 'xlsx' || extension === 'xls') {
      manejarExcel(file);
    } else {
      Swal.fire("Archivo inválido", "Solo se permiten archivos CSV o Excel.", "warning");
    }
  };

  /* =========================
     INPUT / DRAG & DROP
  ========================= */

  const subirArchivoInput = (e) => {
    const file = e.target.files[0];
    if (file) manejarArchivo(file);
    e.target.value = null;
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files.length > 0) {
      manejarArchivo(e.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => setDragOver(false);

  /* =========================
     VALIDACIONES Y ENVÍO
  ========================= */

  const subirArchivo = (data) => {
    if (!tieneTodosLosCampos(data, camposObligatorios)) {
      Swal.fire(
        "Archivo inválido",
        "Revisá que las columnas se llamen exactamente como en el archivo de ejemplo.",
        "warning"
      );
      return;
    }

    if (!props.cursoActual?.nombreCurso || !props.cursoActual?.tituloCertificado) {
      Swal.fire("Error", "No se encontró el curso actual.", "error");
      return;
    }

    let comparar = { paraAgregar: data };

    if (Array.isArray(props.ListaExistente) && props.ListaExistente.length > 0) {
      comparar = comparaExistenciasPorDNI(data, props.ListaExistente);
    }

    if (comparar.paraAgregar.length === 0) {
      Swal.fire("Sin novedades", "Todos los registros ya existen.", "info");
      return;
    }

    Swal.fire({
      title: `¿Agregar ${comparar.paraAgregar.length} registros nuevos?`,
      text: `Curso: ${props.cursoActual.tituloCertificado}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        enviarDatos(comparar.paraAgregar);
      }
    });
  };

  const enviarDatos = async (lista) => {
    setCargando(true);
    try {
      const client = axios.create({
        baseURL: process.env.REACT_APP_BASEURL + "certificados/creaMasivo"
      });

      const respuesta = await client.post('/' + props.cursoActual.nombreCurso, lista);

      Swal.fire(
        "Carga exitosa",
        `Se incorporaron ${respuesta.data.Contador} registros.`,
        "success"
      );
      props.myID("dale");
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo enviar la información.", "error");
    } finally {
      setCargando(false);
    }
  };

  const volver = () => props.myID("dale");

  return (
    <div className='p-4 text-center'>
      <h3>Módulo de carga masiva (CSV / Excel)</h3>

      <div
        className={`mb-3 p-5 rounded border ${dragOver ? 'bg-light border-primary' : 'bg-white border-secondary'}`}
        style={{ borderStyle: 'dashed', cursor: 'pointer' }}
        onClick={() => fileInputRef.current.click()}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <h2 className='' style={{color:"black"}}>📥 Arrastrá CSV o Excel aquí</h2>
        <small  style={{color:"black"}}>.csv | .xlsx | .xls</small>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={subirArchivoInput}
          style={{ display: 'none' }}
        />
      </div>

      {cargando ? <Spinner /> : (
        <CSVLink
          data={[]}
          filename={"Ejemplo-Cursantes.csv"}
          separator=";"
          headers={headers}
          className="btn btn-primary"
        >
          Descargar archivo de ejemplo
        </CSVLink>
      )}

      <div className="mt-3">
        <button className="btn btn-secondary" onClick={volver}>Cancelar</button>
      </div>
    </div>
  );
}

export default CargaMasiva;
